import React, { useState } from 'react';
import Button from '../../forms/Button';
import Checkbox from '../../forms/Checkbox';
import Modal from '../../helpers/Modal';
import { Warning } from '@material-ui/icons';

const RecoveryCodesModal = ({ recoveryCodes, onClose }) => {
    const [acknowledged, setAcknowledged] = useState(false);
    const [copied, setCopied] = useState(false);

    const handleCopyAll = () => {
        const codesText = recoveryCodes.join('\n');
        navigator.clipboard.writeText(codesText);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const handleDownload = () => {
        const codesText = `Clear'em Recovery Codes\n${'='.repeat(30)}\n\nStore these codes safely. Each code can only be used once.\n\n${recoveryCodes.join('\n')}\n\nGenerated: ${new Date().toLocaleString()}`;
        const blob = new Blob([codesText], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'clearem-recovery-codes.txt';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    return (
        <Modal open={true} onClose={onClose} className="ckp-recovery-codes-modal">
            <div className="ckp-recovery-codes-header">
                <h1 className="ckp-admin-modal-forms-title ckp-ts-h1">Save Your Recovery Codes</h1>
            </div>

            <div className="ckp-recovery-codes-body">
                <div className="ckp-recovery-codes-warning">
                    <Warning className="ckp-recovery-codes-warning-icon" />
                    <p>
                        Store these codes safely. Each code can only be used once to log in if you lose access to your
                        authenticator app. You won't be able to see these codes again.
                    </p>
                </div>

                <div className="ckp-recovery-codes-grid">
                    {recoveryCodes.map((code, index) => (
                        <div key={index} className="ckp-recovery-code-item">
                            <span className="ckp-recovery-code-number">{index + 1}.</span>
                            <code className="ckp-recovery-code">{code}</code>
                        </div>
                    ))}
                </div>

                <div className="ckp-recovery-codes-checkbox">
                    <Checkbox
                        name="acknowledged"
                        checked={acknowledged}
                        onChange={e => setAcknowledged(e.target.checked)}
                        label="I have saved these recovery codes in a secure location"
                    />
                </div>
            </div>

            <div className="ckp-recovery-codes-footer">
                <div className="ckp-recovery-codes-actions">
                    <Button
                        type="button"
                        className={`ckp-buttons is-small is-secondary ${copied ? 'is-copied' : ''}`}
                        onClick={handleCopyAll}
                        label={copied ? 'COPIED' : 'COPY ALL'}
                    />
                    <Button
                        type="button"
                        className="ckp-buttons is-auto-width is-secondary"
                        onClick={handleDownload}
                        label="DOWNLOAD AS .TXT"
                    />
                </div>
                <Button className="ckp-buttons is-small" label="Continue" inactive={!acknowledged} onClick={onClose} />
            </div>
        </Modal>
    );
};

export default RecoveryCodesModal;
